import { useUser, useClerk } from '@clerk/clerk-react';
import { useState, useEffect } from 'react';

function Dashboard() {
  var user = useUser().user;
  var signOut = useClerk().signOut;
  var userState = useState([]);
  var drops = userState[0];
  var setDrops = userState[1];
  var loadingState = useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];
  var errorState = useState(null);
  var error = errorState[0];
  var setError = errorState[1];

  useEffect(function() {
    async function fetchDrops() {
      try {
        var res = await fetch(
          process.env.REACT_APP_WORKER_URL + '/drops?clerkUserId=' + user.id
        );
        if (!res.ok) throw new Error('Failed to load drops (' + res.status + ')');
        var data = await res.json();
        setDrops(data.drops);
      } catch(err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    if (user && user.id) fetchDrops();
  }, [user]);

  function getStatusLabel(status) {
    if (status === 'collecting') return 'Collecting redemptions';
    if (status === 'fulfilling') return 'Fulfilling';
    if (status === 'shipped') return 'Shipped';
    return status;
  }

  return (
    <main>
      <section>
        <p>{user && (user.fullName || (user.emailAddresses && user.emailAddresses[0] && user.emailAddresses[0].emailAddress))}</p>
        <button onClick={function() { signOut({ redirectUrl: '/' }); }}>Sign Out</button>
      </section>

      <h1>My Drops</h1>

      {loading && <p>Loading your drops...</p>}
      {error && <p style={{ color: 'red' }}>Error: {error}</p>}
      {!loading && !error && drops.length === 0 && (
        <p>No drops yet. <a href="/">Browse the catalogue.</a></p>
      )}

      {drops.map(function(drop) {
        return (
          <div key={drop.id} style={{ borderTop: '1px solid #ccc', paddingTop: '1rem', marginTop: '1rem' }}>
            <h2>{drop.dropSlug}</h2>
            <p>Status: {getStatusLabel(drop.status)}</p>
            <p>Purchased: {drop.purchasedAt ? new Date(drop.purchasedAt).toLocaleDateString() : '-'}</p>
            <p>Claims: {drop.unitsClaimed} of {drop.unitCountPurchased}</p>

            {drop.redemptionLink && (
              <p>Recipient link: <a href={drop.redemptionLink} target="_blank" rel="noreferrer">{drop.redemptionLink}</a></p>
            )}

            {drop.unitsClaimed > 0 && (
              <a href={process.env.REACT_APP_WORKER_URL + '/claims/csv?dropId=' + drop.dropId} target="_blank" rel="noreferrer">
                Download Claims CSV
              </a>
            )}

            {drop.status === 'shipped' && drop.creditIssued > 0 && (
              <p>Store credit issued: ${drop.creditIssued.toLocaleString()}</p>
            )}
          </div>
        );
      })}
    </main>
  );
}

export default Dashboard;